export interface GetCondensados {
  condensados: any;
  condensadosLoading: boolean;
}

export interface PutAutorizar {
  autorizando: boolean;
}

export interface ExpedienteValidacionStore
  extends GetCondensados,
    PutAutorizar {
  userContext?: any;
}

export const expedienteValidacionStore: (
  state
) => ExpedienteValidacionStore = state => {
  const { expedientes, user } = state;

  return {
    condensados: expedientes.condensados,
    condensadosLoading: expedientes.condensadosLoading,
    autorizando: expedientes.autorizando,
    userContext: user.userContext
  };
};
